import { ArrowLeft } from "lucide-react";
import { useState } from "react";
import { BrandCardHeader } from "#/components/brand/BrandCardHeader";
import { Button } from "#/components/ui/button";
import { Card, CardContent } from "#/components/ui/card";
import { Input } from "#/components/ui/input";
import { StatusMessage } from "#/components/ui/status-message";
import { formatSchemaError, getFieldSchema, isSchemaError, parseSchema, validateField } from "#/lib/validation";
import { LoadingButton } from "#components/ui/loading-button.jsx";
import { emailSchema } from "./ChangeEmailCard.schema";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ChangeEmailCard({
  handleEmailUpdate,
  onBack,
  statusMessage,
  isLoading = false
}) {
  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });
  const [errors, setErrors] = useState({});
  const validateFormField = (name, value) => {
    const fieldSchema = getFieldSchema(emailSchema, name);
    if (fieldSchema) {
      const error = validateField(fieldSchema, value);
      if (error) {
        setErrors(prev => ({
          ...prev,
          [name]: error
        }));
      } else {
        setErrors(prev_0 => {
          const {
            [name]: _,
            ...rest
          } = prev_0;
          return rest;
        });
      }
    }
  };
  const handleChange = (name_0, value_0) => {
    setFormData(prev_1 => ({
      ...prev_1,
      [name_0]: value_0
    }));
    validateFormField(name_0, value_0);
  };
  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const validatedData = parseSchema(emailSchema, formData);
      const response = await handleEmailUpdate(validatedData.email, validatedData.password);
      if (!response.success) {
        setErrors({
          form: response.message
        });
      }
    } catch (error_0) {
      if (isSchemaError(error_0)) {
        setErrors(formatSchemaError(error_0));
      }
    }
  };
  return /*#__PURE__*/_jsxs(Card, {
    className: "m-auto w-screen overflow-y-auto rounded-none bg-card shadow-none sm:max-h-[calc(100vh-112px)] sm:max-w-md sm:rounded-lg sm:shadow-lg sm:shadow-zinc-500/10",
    children: [/*#__PURE__*/_jsx(BrandCardHeader, {
      title: "\xC4ndra e-post",
      subtitle: "Ange din nya e-postadress och bekr\xE4fta med ditt l\xF6senord"
    }), /*#__PURE__*/_jsx(CardContent, {
      className: "space-y-6 p-6",
      children: /*#__PURE__*/_jsxs("form", {
        onSubmit: handleSubmit,
        className: "space-y-4",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "space-y-2",
          children: [/*#__PURE__*/_jsx(Input, {
            type: "email",
            placeholder: "Ny e-postadress",
            value: formData.email,
            onChange: e_0 => handleChange("email", e_0.target.value),
            error: errors.email
          }), /*#__PURE__*/_jsx(Input, {
            type: "password",
            placeholder: "Ditt l\xF6senord",
            value: formData.password,
            onChange: e_1 => handleChange("password", e_1.target.value),
            error: errors.password
          })]
        }), (errors.form || statusMessage) && /*#__PURE__*/_jsx(StatusMessage, {
          message: errors.form || statusMessage?.message || "",
          variant: errors.form ? "error" : statusMessage?.variant || "error"
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex flex-col gap-2",
          children: [/*#__PURE__*/_jsx(LoadingButton, {
            type: "submit",
            loading: isLoading,
            children: "Spara e-post"
          }), /*#__PURE__*/_jsxs(Button, {
            type: "button",
            variant: "outline",
            onClick: onBack,
            disabled: isLoading,
            children: [/*#__PURE__*/_jsx(ArrowLeft, {
              className: "mr-2 h-4 w-4"
            }), "Tillbaka"]
          })]
        })]
      })
    })]
  });
}